module.exports = __webpack_public_path__ + "img/Edge Cases.58cc095d.svg";